module.exports = __webpack_public_path__ + "static/media/pro4.934849eb.jpg";